module.exports = __webpack_public_path__ + "img/sharp12-1.bc7ab3ff.png";